module.exports = {"540229100":"德吉林镇","540229200":"康雄乡","540229201":"普松乡","540229202":"帕当乡","540229203":"然巴乡","540229204":"查巴乡","540229205":"切娃乡","540229206":"姆乡","540229207":"仁布乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540229.json
// module id = 2696
// module chunks = 0